var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"mt-4",attrs:{"fluid":""}},[_c('b-btn',{attrs:{"click":_vm.payAll}},[_vm._v("Run Auto Pay")]),_c('b-form'),_c('b-table',{attrs:{"responsive":"","items":_vm.items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }